import { render } from "./bruteClueManual.vue?vue&type=template&id=61186f6d"
import script from "./bruteClueManual.vue?vue&type=script&lang=js"
export * from "./bruteClueManual.vue?vue&type=script&lang=js"

import "./bruteClueManual.vue?vue&type=style&index=0&id=61186f6d&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__